var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7279 10.0763L14.3137 8.66207L5 17.9758V19.39H6.41421L15.7279 10.0763ZM17.1421 8.66207L18.5563 7.24786L17.1421 5.83364L15.7279 7.24786L17.1421 8.66207ZM7.24264 21.39H3V17.1473L16.435 3.71232C16.8256 3.3218 17.4587 3.3218 17.8492 3.71232L20.6777 6.54075C21.0682 6.93127 21.0682 7.56444 20.6777 7.95496L7.24264 21.39Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.71898992677d326c9a8d52611f0cf030.svg";
export { ForwardRef as ReactComponent };